import {
  GetOAuthToken,
  GetStateStorage,
  GetStateExpireTimerData,
  IsValidLoginAuth,
} from 'common/storage';

/**
 * Snapshot of the auth-related storage state, used to diagnose why a user
 * was bounced back to the sign-in screen (partial session, blocked storage,
 * expired timer, etc.). Booleans only — never the actual values.
 */
export const getAuthStorageDiagnostics = () => {
  const diag = {};

  try {
    const testKey = 'LG_STORAGE_PROBE';
    localStorage.setItem(testKey, '1');
    diag.localStorageWritable = localStorage.getItem(testKey) === '1';
    localStorage.removeItem(testKey);
  } catch (e) {
    diag.localStorageWritable = false;
    diag.storageError = (e && e.name) || String(e);
  }

  try {
    diag.hasOAuthToken = Boolean(GetOAuthToken());

    const expireRaw = GetStateExpireTimerData();
    diag.hasExpireTimer = expireRaw !== null && expireRaw !== undefined;
    diag.expireTimerExpired = diag.hasExpireTimer
      ? Number(expireRaw) < Date.now()
      : null;

    const state = GetStateStorage();
    diag.hasStateData = Boolean(state && Object.keys(state).length > 0);
    diag.stateIsUserLoggedIn = Boolean(state && state.isUserLoggedIn);
    diag.stateHasUserData = Boolean(state && state.userData);
    diag.stateHasTokenData = Boolean(state && state.tokenData);

    diag.isValidLogin = IsValidLoginAuth();
  } catch (e) {
    diag.readError = String(e);
  }

  return diag;
};
